export default "__VITE_ASSET__Bni7yaDl__"